<template>
  <div class="doclist">
    <!-- 评分蒙版 -->
    <div class="rate-mask" v-if="isRateMaskShow">
      <div class="rate-area">
          <div class="rate-text">
            <h3>请给出您的评价</h3>
            <div @click="handleRateCancel" class="rate-cancel-icon" src="">
            </div>
          </div>
          <div class="rate-block">
            <el-rate class="rate-choose" v-model="rateValue"></el-rate>
          </div>
          <div class="rate-function">
            <div @click="handleRateCancel" class="rate-cancel">取消</div>
            <div @click="handleRate">提交</div>
          </div>
      </div>
    </div>
    <!-- 详情页大板 -->
    <div class="doclist-lastarea">
      <!-- 左侧分类及分页列表 -->
      <div class="doclist-lastarea-l">
        <el-breadcrumb separator-class="el-icon-arrow-right"
          style="
            margin-left: -26px;
            margin-top: -20px;
            margin-bottom: 40px;
          "
        >
          <el-breadcrumb-item :to="{ path: '/onlineTraining' }">知识培训</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/courseList', query: { type: 'know'} }">技术视频</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/courseList', query:{'menuType': videoMessage? videoMessage.parentId : '', type: 'know'} }">{{videoMessage ? videoMessage.parentName : '详情'}}</el-breadcrumb-item>
          <el-breadcrumb-item v-show="false">详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="docdetail-message" v-if="videoMessage">
          <h2>
            {{videoMessage.videoTitle}}
          </h2>
          <div class="docdetail-about">
            <!-- <img :src="videoMessage.userAvatarURL || defaultImg" :alt="videoMessage.userNickname"/> -->
            <div>
              <!-- {{videoMessage.userNickname}} 上传 |  -->
              {{videoMessage.videoCommentCount}} 个回复 | {{videoMessage.videoViewCount}} 次浏览 | {{videoMessage.videoCollectCount}} 次收藏 | {{videoMessage.createTime}}
            </div>
            <div class="docdetail-showmark">
              文档评分：
              <el-rate
                v-model="value"
                disabled
                show-score
                disabled-void-icon-class="el-icon-star-off"
                text-color="#1D65A8"
                disabled-void-color="#1D65A8"
                score-template="{value}">
              </el-rate>
            </div>
            <div class="docdetail-likeicon" @click.stop="changeLikeState">
              <img :src="videoMessage.collectionDataId?likeUrl:notLikeUrl" alt="收藏"/>
              <div>{{videoMessage.collectionDataId?'已收藏':'收藏'}}</div>
            </div>
          </div>
        </div>
        <!-- <ul v-if="svgList">
          <li v-for="(item, index) in svgList" :key="index">
            <img :src="item">
          </li>
        </ul> -->
        <div class="vedio-player" v-if="videoMessage">
          <video id="myVideo"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            oncontextmenu="return false"
            controlsList="nodownload"
            :autoplay="false"
            preload="auto"
            style="width: 830px;height: 440px;cursor: pointer;"
            ref="player"
            :poster="videoMessage.path + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_830,h_440,m_fast'">
            <source :src="videoMessage.path" type="video/mp4">
          </video>
        </div>
        <div style="display:flex" class="docdetail-function">
          <!-- <div @click="download">立即下载</div> -->
          <div style="flex:1;visibility: hidden"></div>
          <div style="margin:0;color: white;background: #1D65A8" @click="isRateMaskShow = true">评价</div>
        </div>
        <div class="docdetail-trivia">
          <h3>相关视频</h3>
          <div
            v-if="relatedDocuments === null || relatedDocuments.length === 0"
            style="margin: 40px 0; font-size: 20px; text-indent: 2em;"
          >
            暂无相关视频
          </div>
          <ul v-if="relatedDocuments">
            <li v-for="(item, index) in relatedDocuments" :key="index" @click="jumpDocDetail(item.totalId, item)">
              <img alt="播放" class="k-video-play" src="data:image/png;base64,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">
              <img :alt="item.fileVideoName" :src="item.path + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_263,h_160,m_fast'">
              <h3 class="overell">{{item.fileVideoName}}</h3>
              <div class="k-video-text">
                <p>{{item.fileVideoCreateTime}}</p>
                <div class="k-video-collect" @click.stop="changeVideoLikeState(index, item)">
                  <img style="margin-top: 7px" class="k-docview-likeicon" :src="item.collectionDataId?likeUrl:notLikeUrl" alt="收藏"/>
                  <div style="margin-right: 0" class="k-docview-collect">{{item.collectionDataId?'已收藏':'收藏'}}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="docdetail-product">
          <h3>相关产品</h3>
          <div
            v-if="relatedProducts === null || relatedProducts.length === 0"
            style="margin: 40px 0; font-size: 20px; text-indent: 2em;"
          >
            暂无相关产品
          </div>
          <ul v-if="relatedProducts">
            <li v-for="item in relatedProducts" :key="item.id">
              <img :src="item.pollings[0].url" :alt="item.name"/>
              <p>{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="docdetail-hotdiscuss">
          <h3>热门评论 <span v-if="commentCounts">（共{{commentCounts}}条）</span></h3>
          <h3 v-if="commentList === null || commentList.length === 0">共0条 暂无评论</h3>
          <textarea
          style="
              padding: 10px;
              border-radius: 4px;
            "
          placeholder="请输入你的评论（不得超过2000字）..." v-model.trim="discussText"></textarea>
          <div @click="publishjl" class="docdetail-discuss-publish">发表</div>
          <ul v-if="commentList">
            <li v-for="item in commentList" :key="item.id" class="docdetail-discuss-detail">
              <img :src="item.userAvatarURL || defaultImg" :alt="item.userNickname"/>
              <div>
                <p>{{item.userNickname}}</p>
                <p>{{item.videoRepliyContent}}</p>
                <p>{{item.createTime}}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="doclist-pagination" v-if="commentList === null || commentList.length !== 0">
          <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
          <div class="doclist-omit">{{lastOmit}}</div>
          <ul>
            <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
          </ul>
          <div class="doclist-omit">{{nextOmit}}</div>
          <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
          <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
          <div class="doclist-jump" @click="jumpFarPage">确定</div>
        </div>
      </div>
      <!-- 右侧上传及推荐列表 -->
      <div class="doclist-lastarea-r">
        <!-- 热门下载排行列表 -->
        <div class="doclist-hotdownloads">
          <h3>高分视频排行</h3>
          <ul v-if="hotDownloads">
            <li v-for="(item,index) in hotDownloads" :key="item.id" @click="jumpDocDetail(item.id, item)">
              <img alt="高分视频" v-if="index + 1 === 1" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAkCAYAAABxE+FXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjQxQzlEQkVBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjQxQzlEQkZBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNDFDOURCQ0ExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCNDFDOURCREExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpwY+9gAAAHZSURBVHjaYpRNXfGfYQDA1ho3BiaGAQSjlo88y1nI0aQswcvgYSgD57/68J1h9fEHtLech4OFYW62LYOSOC9c7PLDd2RZTnKw9yaYo1hMl2Dn42RlqAszYPA0kqFfnIvxczCEWysyJDipMYjycdAvwbGzMjOc6PBlYGFmon9WY2RkwLD4zvNPGOr+0zqf//z9l6F7w2UGn7bd9Ivz20Cfrjx6j2EdMCu9+fyTgZWKUYDX8h+//jI4128fLdtHLR+1fNRy+rVkfv/9xyCXtnI02Eeo5ZzsLPRNcExMjOBmc7anJoOiGC/Dwv23GebsucXw9vMP2lnOysLEEGiuwJDlocGI3HoFOSLZWY1h2eF7/2fuusHw/P036lnOBQzaKFtlhjQ3dUYJAU6sajjYmBmSnFUZYx2UGdYef/B/2o7rDA9efSHfcgFudmCLVYUhyUmNUYCbjbjQAbZyImyUGMOArd3Npx//n7L9OsPNpx+Itxzku1RXdYZoO2VGLjITFBOw5elvJscIxAy7Lj77P3nbNYaL99/itlwRGI+Z7hoMwZYKjNRsp7npSzECMcPh6y/Bjjhx8xVC0rN55//NZx79//fvP8P//7THZ+68+R8/6dB/YP/uP0CAAQBiHNQeibKNaAAAAABJRU5ErkJggg==">
              <img alt="高分视频" v-if="index + 1 === 2" src="data:image/png;base64,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">
              <img alt="高分视频" v-if="index + 1 === 3" src="data:image/png;base64,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">
              <p><span>{{index + 1}}.</span>{{item.videoTitle}}</p>
            </li>
          </ul>
        </div>
        <!-- 热门推荐列表 -->
        <div class="doclist-hotcommend">
          <h3>热门推荐</h3>
          <ul v-if="hotCommend">
            <li v-for="item in hotCommend" :key="item.id" @click="jumpDocDetail(item.id, item)">
              <div></div>
              <p>{{item.videoTitle}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
import { track } from '@/utils/knowledgeEventTracking'
export default {
  data () {
    return {
      defaultImg: require('@/assets/img/defaultPeopleImg.png'),
      likeUrl: 'data:image/png;base64,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',
      notLikeUrl: 'data:image/png;base64,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',
      hotDownloads: null,
      hotCommend: null,
      currentPage: 1,
      totalPage: 8,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      commentCounts: null,
      commentList: null,
      videoMessage: null,
      relatedDocuments: null,
      relatedProducts: null,
      discussText: '',
      svgList: null,
      value: null,
      rateValue: 0,
      isRateMaskShow: false,
      timeout: false
    }
  },
  computed: {
    parentName () {
      return this.videoMessage ? this.videoMessage.parentName : '技术文档详情'
    }
  },
  methods: {
    handleRate () {
      // console.log(this.rateValue)
      if (this.rateValue === 0) {
        this.$message.warning('评分不可以为0')
      } else {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideo/technicalvideoscore/save`, {
          technicalVideoId: this.$route.query.videoId,
          videoScore: this.rateValue
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('评价成功')
              this.rateValue = 0
              this.isRateMaskShow = false
              this.$http.get(`${window.SITE_CONFIG['apiURL']}/technicalvideo/technicalvideo/technicalVideoInfoPage`, { params: { id: this.$route.query.videoId } })
                .then(item => {
                  this.value = Number(item.result.data.videoScore)
                })
            } else {
              if (data.msg === '登录后再评分') {
                this.$router.push({ name: 'login' })
              } else {
              }
            }
          })
          .catch(() => {
          })
      }
    },
    handleRateCancel () {
      this.isRateMaskShow = false
      this.rateValue = 0
    },
    // download () {
    //   let a = document.createElement('a')
    //   a.href = `${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfile/aliOssDownLoad/${this.videoMessage.id}`
    //   a.click()
    // },
    changeLikeState () {
      if (getAccessToken()) {
        if (this.videoMessage.collectionDataId === null) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`, { collectionType: 'VIDEO', collectionDataId: this.$route.query.videoId })
            .then(({ data }) => {
              if (data.code === 0) {
                this.videoMessage.collectionDataId = 1
                this.$message.success('收藏成功')
                track.clickVideoCollection(this.videoMessage.videoTitle)
              }
            })
            .catch(() => {
              this.$router.push({ name: 'login' })
            })
        } else {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`, { collectionType: 'VIDEO', collectionDataId: this.$route.query.videoId })
            .then(({ data }) => {
              if (data.code === 0) {
                this.videoMessage.collectionDataId = null
                this.$message.success('取消收藏成功')
              }
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    changeVideoLikeState (index, item) {
      if (item.collectionDataId === null) {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`, { collectionType: 'VIDEO', collectionDataId: item.totalId })
          .then(() => {
            this.relatedDocuments[index].collectionDataId = 1
            this.$message.success('收藏成功')
            track.clickVideoCollection(item.videoTitle)
          })
          .catch(() => {
          })
      } else {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`, { collectionType: 'VIDEO', collectionDataId: item.totalId })
          .then(() => {
            this.relatedDocuments[index].collectionDataId = null
            this.$message.success('取消收藏成功')
          })
          .catch(() => {
          })
      }
    },
    publishDiscuss () {
      if (this.discussText === '') {
        this.$message.error('请输入评论内容再进行发表')
      } else {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideorepliypost/save`, { technicalVideoId: this.$route.query.videoId, videoRepliyContent: this.discussText, videoRepliyAnonymous: true, videoRepliyVisible: true, status: true })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('回复成功，请等待审核')
              this.discussText = ''
            } else {
              if (data.msg === '内容过长，请输入2000字以内') {
                this.$message.warning('内容过长，请输入2000字以内')
              } else {
                this.$router.push({ name: 'login' })
              }
            }
          })
      }
    },
    publishjl () {
      if (this.timeout === false) {
        this.timeout = true
        this.publishDiscuss()
      } else {
        this.$message.warning('您发表评论过于频繁，请在30s后再进行评论')
        let that = this
        setTimeout(function () {
          that.timeout = false
        }, 30000)
      }
    },
    jumpDocDetail (item, item2) {
      track.clickVideoDetail(item2.videoTitle)
      this.$router.push({
        name: 'knowledgevideoDetil',
        query: {
          videoId: item
        }
      })
    },
    jumpDocDetail2 (item) {
      this.$router.push({
        name: 'knowledgevideoDetil',
        query: {
          fileId: item
        }
      })
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.changeCommentListPage(page)
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.changeCommentListPage(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    changeCommentListPage (page) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideorepliypost/searchVideoComments`, { page: page, limit: 8, technicalVideoId: this.$route.query.videoId })
        .then(({ data }) => {
          this.commentList = data.data.data
        })
    }
  },
  watch: {
    '$route' (to, from) {
      setTimeout(() => {
        this.currentPage = 1
        this.jumpTargetPage = 1
        this.$refs.player.load()
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideo/hotDownload`)
          .then(({ data }) => {
            this.hotDownloads = data.data.slice(0, 10)
          })
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideo/hotRecommend`)
          .then(({ data }) => {
            this.hotCommend = data.data.slice(0, 10)
          })
        // this.$http.post(`${window.SITE_CONFIG['apiURL']}/attribute/filevideotypeattribute/inquiryRelevantInformation`, {totalId: this.$route.query.videoId, labelType: 'VIDEO'})
        // .then(data => {
        //   this.relatedDocuments = data.result.data.data
        // })
        // this.$http.post(`${window.SITE_CONFIG['apiURL']}/attribute/filevideotypeattribute/inquiryRelevantCommodity`, {totalId: this.$route.query.videoId, labelType: 'VIDEO'})
        // .then(data => {
        //   this.relatedProducts = data.result.data.data
        // })
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/filevideotypeattribute/inquiryRelevantInformation`, { totalId: this.$route.query.videoId, labelType: 'VIDEO' })
          .then(() => {
            // this.relatedDocuments = data.result.data.data
            // console.log(data)
          })
        // 埋点
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/knowledgeTrainRecord/save`, {
          userId: this.$store.state.user.id || null,
          eventId: 'TECHNICAL_VIDEO_DETAIL',
          eventType: 'click',
          desc: '技术视频详情',
          source: 'PC',
          stayTime: '',
          busId: this.$route.query.videoId || null
        })
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideo/technicalVideoInfoPage/${this.$route.query.videoId}`, {
          userId: this.$store.state.user.id || null
        })
          .then(({ data }) => {
            this.videoMessage = data.data
            this.value = Number(data.data.videoScore)
          })
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideorepliypost/searchVideoComments`, { page: 1, limit: 8, technicalVideoId: this.$route.query.videoId })
          .then(({ data }) => {
            this.commentCounts = data.data.count
            this.commentList = data.data.data
            var page = Math.ceil(data.data.count / 8)
            this.totalPage = page
            if (page >= 5) {
              this.pageList = [1, 2, 3, 4, 5]
            } else {
              var lessPageList = []
              for (let index = 1; index <= page; index++) {
                lessPageList.push(index)
              }
              this.pageList = lessPageList
              this.nextOmit = ''
            }
          })
      }, 100)
    },
    parentName (newVal) {
      document.title = newVal
    }
  },
  mounted () {
    this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideo/hotDownload`)
      .then(({ data }) => {
        this.hotDownloads = data.data.slice(0, 10)
      })
    this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideo/hotRecommend`)
      .then(({ data }) => {
        this.hotCommend = data.data.slice(0, 10)
      })
    // this.$http.post(`${window.SITE_CONFIG['apiURL']}/attribute/filevideotypeattribute/inquiryRelevantInformation`, {totalId: this.$route.query.videoId, labelType: 'VIDEO'})
    // .then(data => {
    //   this.relatedDocuments = data.result.data.data
    // })
    // this.$http.post(`${window.SITE_CONFIG['apiURL']}/attribute/filevideotypeattribute/inquiryRelevantCommodity`, {totalId: this.$route.query.videoId, labelType: 'VIDEO'})
    // .then(data => {
    //   this.relatedProducts = data.result.data.data
    // })
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/filevideotypeattribute/inquiryRelevantInformation`, { totalId: this.$route.query.videoId, labelType: 'VIDEO' })
      .then((res) => {
        // this.relatedDocuments = data.result.data.data
        // console.log(data)
        if (res && res.data && res.data.data) {
          this.relatedDocuments = res.data.data.fileVideoRelevantList || null
          this.relatedProducts = res.data.data.commodityEntityList || null
        }
      })
    // 埋点
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/knowledgeTrainRecord/save`, {
      userId: this.$store.state.user.id || null,
      eventId: 'TECHNICAL_VIDEO_DETAIL',
      eventType: 'click',
      desc: '技术视频详情',
      source: 'PC',
      stayTime: '',
      busId: this.$route.query.videoId || null
    })
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideo/technicalVideoInfoPage/${this.$route.query.videoId}`, {
      userId: this.$store.state.user.id || null
    })
      .then(({ data }) => {
        this.videoMessage = data.data
        this.value = Number(data.data.videoScore)
      })
      .catch(() => {
      })
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideorepliypost/searchVideoComments`, { page: 1, limit: 8, technicalVideoId: this.$route.query.videoId })
      .then(({ data }) => {
        this.commentCounts = data.data.count
        this.commentList = data.data.data
        var page = Math.ceil(data.data.count / 8)
        this.totalPage = page
        if (page >= 5) {
          this.pageList = [1, 2, 3, 4, 5]
        } else {
          var lessPageList = []
          for (let index = 1; index <= page; index++) {
            lessPageList.push(index)
          }
          this.pageList = lessPageList
          this.nextOmit = ''
        }
      })
  }
}
</script>

<style scoped>
/* 评分蒙版样式 */
.rate-mask{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.rate-area{
  width: 530px;
  height: 238px;
  background: white;
  display: flex;
  flex-direction: column;
  margin: 20px auto;
}
.rate-text{
  height: 54px;
  display: flex;
  color: #333333;
}
.rate-text h3{
  flex: 1;
  text-indent: 32px;
  line-height: 60px;
}
.rate-choose{
  padding-top: 16px;
  text-align: center;
  transform: scale(2)
}
.rate-cancel-icon{
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDhGREUxQzhBQ0VDMTFFOUFEQTRFRDdENDk2MjI1OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDhGREUxQzlBQ0VDMTFFOUFEQTRFRDdENDk2MjI1OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowOEZERTFDNkFDRUMxMUU5QURBNEVEN0Q0OTYyMjU5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowOEZERTFDN0FDRUMxMUU5QURBNEVEN0Q0OTYyMjU5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmUCvhEAAADHSURBVHjanJIxDoQgEEVHTKxsqfAWnokD4AnYC+DpMFQWBgtr7Nn9JrvJskA2/oSG+S8zmfnkvSdjTAwhUIyx+uCBF0w7DEN0zpG1Vo/j+Oi6jnI6z5PmeY7rutJxHJpJKZsXTPu+XwUYShA6wQuG9X1PSqkLRiGFUwheMA1mLxnwn4OgD5iDoRz0A6YwlIMgRjf116hCCJqm6asrq23vve3cqVht5bVTNYhRaeW1aVrO+RWjEgQhhojjsiwa8LZtmu6G/CnAAHQQF6+gbr3XAAAAAElFTkSuQmCC) no-repeat 20px 20px;
  width: 54px;
  height: 54px;
  user-select: none;
  cursor: pointer;
}
.rate-block{
  flex: 1;
}
.rate-function{
  height: 50px;
  line-height: 50px;
  display: flex;
}
.rate-function div{
  box-sizing: border-box;
  width: 265px;
  height: 100%;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.rate-cancel{
  box-sizing: border-box;
  color: #1D65A8;
  border-top: 1px solid #1D65A8;
  border-right: 1px solid #1D65A8;
  border-bottom: 1px solid #1D65A8;
  border-left: 1px solid #1D65A8;
}
.rate-function div:nth-of-type(2){
  background: #1D65A8;
  color: white;
}
/* 热门下载排行 */
.doclist-hotdownloads ul li{
  user-select: none;
  cursor: pointer;
}.doclist-hotcommend ul li{
  user-select: none;
  cursor: pointer;
}
.doclist{
  width: 1230px;
  padding: 0 20px;
  margin: 0 auto;
  padding-top: 20px;
  margin-bottom: 20px;
}
.doclist-lastarea{
  display: flex;
}
.doclist-lastarea-l{
  width: 890px;
  padding: 20px 30px 0 30px;
  margin-right: 20px;
}
.doclist-lastarea-r{
  flex: 1;
}
.doclist-hotdownloads{
  margin: 12px 20px 62px 26px;
}
.doclist-hotdownloads h3{
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 18px;
}
.doclist-hotdownloads ul li{
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
}
.doclist-hotdownloads ul li img{
  position: absolute;
  width: 15.5px;
  height: 18px;
  left: 0;
  top: 8px;
}
.doclist-hotdownloads ul li p{
  width: 233px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
.doclist-hotdownloads ul li p span{
  display: inline-block;
  width: 23px;
}
/* 热门推荐样式 */
.doclist-hotcommend{
  margin: 0 20px 0 26px;
}
.doclist-hotcommend h3{
  margin-top: 0;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 18px;
}
.doclist-hotcommend ul li{
  display: flex;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
}
.doclist-hotcommend ul li div{
  width: 6px;
  height: 6px;
  margin: auto 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #1D65A8;
}
.doclist-hotcommend ul li p{
  margin: 0;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
/* 左侧列表样式 */
.docdetail-message h2{
  line-height: 46px;
  font-size: 24px;
  color: #333333;
  font-weight: 600;
  margin-bottom: 9px;
  word-break: break-all;
}
.docdetail-about{
  height: 30px;
  line-height: 30px;
  display: flex;
  margin-bottom: 20px;
}
.docdetail-about img{
  width: 30px;
  height: 30px;
  margin-right: 20px;
}
.docdetail-showmark{
  margin-left: 52px;
  flex: 1;
  display: flex;
}
.docdetail-showmark .el-rate{
  margin: auto 0 auto 0;
}
.docdetail-likeicon{
  display: flex;
  color: #1D65A8;
  user-select: none;
  cursor: pointer;
}
.docdetail-about .docdetail-likeicon img{
  width: 16px;
  height: 16px;
  margin: auto 7px auto 0;
}
.docdetail-function{
  margin-top: 17px;
  margin-bottom: 96px;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  display: flex;
}
.docdetail-function div{
  width: 150px;
  height: 40px;
  box-sizing: border-box;
  user-select: none;
  cursor: pointer;
}
.docdetail-function div:nth-of-type(1){
  background: #1D65A8;
  color: #ffffff;
  margin: 0 10px 0 262px;
}
.docdetail-function div:nth-of-type(2){
  border: 1px solid #1D65A8;
  color: #1D65A8;
}
/* 分页样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
}
.doclist-pagination{
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
/* 评论区域样式 */
.docdetail-hotdiscuss h3{
  font-size: 20px;
  margin-bottom: 36px;
}
.docdetail-hotdiscuss span{
  font-size: 14px;
  color: #676767;
  line-height: 26px;
  font-weight: normal;
}
.docdetail-hotdiscuss textarea{
  width: 831px;
  height: 190px;
  line-height: 30px;
  resize: none;
  font-size: 18px;
}
.docdetail-discuss-publish{
  width: 150px;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  background: #1D65A8;
  text-align: center;
  margin-top: 16px;
  margin-left: 681px;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  margin-bottom: 20px;
}
.docdetail-discuss-detail{
  display: flex;
  margin-bottom: 55px;
}
.docdetail-discuss-detail img{
  width: 55px;
  height: 55px;
  margin-right: 16px;
}
.docdetail-discuss-detail p {
  line-height: 28px;
}
.docdetail-discuss-detail p:nth-of-type(1){
  font-weight: bold;
  color: #333333;
  font-size: 16px;
}
.docdetail-discuss-detail p:nth-of-type(3){
  color: #a7a7a7;
  font-size: 12px;
}
.docdetail-discuss-detail p:nth-of-type(2){
  font-weight: bold;
  color: #3b3b3b;
  font-size: 14px;
}
/* 相关文档样式 */
.docdetail-trivia .k-video-play{
  width: 38.7px;
  height: 38.7px;
  position: absolute;
  top: 60px;
  left: 108px;
}
.k-video-adv{
  width: 316px;
  height: 522px;
}
.k-video-collect{
  display: flex;
}
.k-video-text{
  display: flex;
  line-height: 26px;
}
.k-video-text p{
  flex: 1;
  font-size: 12px;
  color: #666666;
}
.docdetail-trivia .k-docview-likeicon{
  width: 14px;
  height: 13px;
  display: block;
  margin-right: 4px;
  margin-top: 4px;
}
.k-docview-collect{
  color: #1d65a8;
  margin-right: 32px;
}
.docdetail-trivia h3{
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}
.docdetail-trivia ul{
  display: flex;
}
.docdetail-trivia ul li{
  width: 263px;
  margin-right: 21px;
  margin-top: 40px;
  margin-bottom: 85px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  cursor: pointer;
  user-select: none;
  position: relative;
}
.docdetail-trivia ul li img{
  width: 263px;
  height: 160px;
}
/* 相关产品样式 */
.docdetail-product h3{
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}
.docdetail-product ul{
  display: flex;
}
.docdetail-product ul li{
  width: 166px;
  text-align: center;
  margin-right: 58px;
  margin-top: 40px;
  margin-bottom: 85px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.docdetail-product ul li img{
  width: 140px;
  height: 130px;
  margin: 0 auto;
}
p {
  margin: 0;
}
</style>
